import dynamic from "next/dynamic";

import type { Props as AppBarProps } from "~/components/app-bar";
import type { Props as SnackbarProviderProps } from "~/components/common/snackbar";
import type { Props as C2paProviderProps } from "~/components/content/content-schema-render/image/starling-image-popover/contexts";
import type { Props as MixpanelProps } from "~/components/mixpanel";
import type { Props as NewsTickerProps } from "~/components/news-ticker";
import type { Props as RosettaContextProviderProps } from "~/lib/rosetta";

import type { Props as SdkContextProviderProps } from "./contexts";

export const DynamicContentReactionActionRedirect = dynamic<Record<string, never>>(() =>
  import("~/components/content/content-reaction/content-reaction-action-redirect").then(
    module => module.ContentReactionActionRedirect,
  ),
);

export const DynamicAppBar = dynamic<AppBarProps>(() =>
  import("~/components/app-bar").then(module => module.AppBar),
);

export const DynamicLoginDialog = dynamic<Record<string, never>>(() =>
  import("~/components/login-dialog").then(module => module.LoginDialog),
);

export const DynamicSimpleHooksRunner = dynamic(() =>
  import("~/components/simple-hooks-runner").then(module => module.SimpleHooksRunner),
);

export const DynamicNewsTicker = dynamic<NewsTickerProps>(() =>
  import("~/components/news-ticker").then(module => module.NewsTicker),
);

export const DynamicPopupContainer = dynamic<Record<string, never>>(() =>
  import("~/components/popup-container").then(module => module.PopupContainer),
);

export const DynamicHamburgerMenu = dynamic<Record<string, never>>(() =>
  import("~/components/hamburger-menu").then(module => module.HamburgerMenu),
);

export const DynamicSnackbarProvider = dynamic<SnackbarProviderProps>(() =>
  import("~/components/common/snackbar").then(module => module.SnackbarProvider),
);

export const DynamicMixpanelProvider = dynamic<MixpanelProps>(() =>
  import("~/components/mixpanel").then(module => module.MixpanelProvider),
);

export const DynamicSdkContextProvider = dynamic<SdkContextProviderProps>(() =>
  import("./contexts").then(module => module.SdkContextProvider),
);

export const DynamicRosettaContextProvider = dynamic<RosettaContextProviderProps>(() =>
  import("~/lib/rosetta").then(module => module.RosettaContextProvider),
);

export const DynamicC2paProvider = dynamic<C2paProviderProps>(() =>
  import("~/components/content/content-schema-render/image/starling-image-popover/contexts").then(
    module => module.C2paProvider,
  ),
);
